// Native forms remain usable without JavaScript. Variant changes reload the
// Shopify-rendered price, availability, image and selling-plan allocations.
document.addEventListener('change', (event) => {
  const select = event.target.closest('[data-wc-variant]');
  if (!select) return;
  const url = new URL(window.location.href);
  url.searchParams.set('variant', select.value);
  window.location.assign(url.toString());
});
document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') document.querySelectorAll('.wc-mobile-nav[open]').forEach((menu) => {
    menu.open = false;
    menu.querySelector('summary').focus();
  });
});
